import { type MDXComponents } from 'mdx/types'

// Components made globally available to every MDX post via <MDXProvider>.
// Start minimal/pass-through; add element overrides (a, img, code, ...) or
// shared embeddable components here as posts need them. Per-post components
// can also be imported directly inside the .mdx file.
export const mdxComponents: MDXComponents = {}
